import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  postAuthProperty as actionPostAuthProperty,
  postAuthPropertyCheck as actionPostAuthPropertyCheck,
  setSignUpType as actionSetSignUpType,
} from '../../../redux/auth/actions';

import { withRouter } from 'react-router-dom';

import { TYPE_GENERIC_HOUSEHOLD_INVITE } from '../config';

import styles from './PropertyRetry.scss';
import qmStyles from '../../../theme/qmStyles';

import AddressAutocomplete from '../../../components/AddressAutocomplete/AddressAutocomplete';
import Button from '../../../components/Button';
import SignUpHelp from '../components/SignUpHelp';
import ToolTip from '../components/ToolTip';

class PropertyRetry extends Component {
  static propTypes = {
    navigateNext: PropTypes.func.isRequired,
    postAuthProperty: PropTypes.func.isRequired,
    postAuthPropertyCheck: PropTypes.func.isRequired,
    setSignUpType: PropTypes.func.isRequired,
  };

  state = {
    address: '',
    apt: '',

    addressData: null,

    error: null,
  };

  addressAutocomplete = React.createRef();

  validate = () => {
    const { addressData } = this.state;
    if (!addressData || !addressData.address) return false;

    if (this.addressAutocomplete && this.addressAutocomplete.current) {
      if (!addressData.street_number) {
        return false;
      }
      if (!addressData.street) {
        return false;
      }
    }

    return true;
  };

  getPayload = () => {
    const { addressData } = this.state;
    return {
      address_line1: addressData.address_line1 || addressData.address,
      city: addressData.city,
      geo_lat: addressData.geo_lat,
      geo_long: addressData.geo_long,
      postal: addressData.postal,
      province: addressData.province,
    };
  };

  // recheck and go to request
  // go to onSuccess
  postCheckData = () => {
    if (!this.validate()) return;
    const { postAuthPropertyCheck, navigateNext, setSignUpType } = this.props;

    const payload = this.getPayload();

    postAuthPropertyCheck(payload)
      .then(data => {
        setSignUpType(TYPE_GENERIC_HOUSEHOLD_INVITE);
        navigateNext({ success: true });
      })
      .catch(error => {
        this.setState({
          error,
        });
      });
  };

  // create property
  // go to onError
  postCreateData = () => {
    if (!this.validate()) return;
    const { postAuthProperty, navigateNext } = this.props;

    const payload = this.getPayload();

    postAuthProperty(payload)
      .then(data => {
        navigateNext({ error: true });
      })
      .catch(error => {
        this.setState({
          error,
        });
      });
  };

  render() {
    const { address, error } = this.state;

    return (
      <div className={styles.container}>
        <div className={styles.content}>
          <h3 className={styles.title}>Something doesn't match</h3>
          <p className={styles.subTitle}>
            We couldn't find anyone with that address
          </p>
          <AddressAutocomplete
            address={address}
            onAddressFinalized={e => this.setState({ addressData: e })}
            hideApt
            inputStyle={{
              marginBottom: qmStyles.gutter,
              paddingRight: 30,
              border: error ? `1px solid ${qmStyles.qmRed}` : '',
            }}
            ref={this.addressAutocomplete}
            required
          />
          <ToolTip />
          <Button
            onClick={this.postCheckData}
            text="Try again"
            style={{
              backgroundColor: qmStyles.qmGreen,
              color: 'white',
              marginBottom: qmStyles.halfGutter,
              width: 360,
            }}
          />
          <Button
            onClick={this.postCreateData}
            text="Create New Property"
            style={{
              marginBottom: 24,
              width: 360,
            }}
          />
          <SignUpHelp style={{ marginBottom: 32 }} />
        </div>
      </div>
    );
  }
}

const bindAction = {
  postAuthProperty: actionPostAuthProperty,
  postAuthPropertyCheck: actionPostAuthPropertyCheck,
  setSignUpType: actionSetSignUpType,
};

export default withRouter(
  connect(
    null,
    bindAction,
  )(PropertyRetry),
);
